import fetchHandler from './Handler';
export const getAllUserAPI = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'users/', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};
